import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LoadingSpinner } from '@doxyme/ui';
import './styles.scss';
export function BackgroundEffectsPlaceholder({ loading, }) {
    const intl = useIntl();
    return (<div className="background-effects__preview__placeholder">
      {loading ? (<div role="progressbar" aria-busy="true" aria-label={intl.formatMessage({
                id: 'backgroundEffects.loading',
                defaultMessage: 'Loading',
            })} aria-valuemin={0} aria-valuemax={100} aria-valuenow={0}>
          <LoadingSpinner />
        </div>) : (<>
          <svg className="background-effects__preview__placeholder__avatar">
            <use xlinkHref="#call-placeholder"/>
          </svg>
          <p>
            <FormattedMessage id="video-settings.camera-disabled"/>
          </p>
        </>)}
    </div>);
}
